import { render, staticRenderFns } from "./maengelTable.vue?vue&type=template&id=70c1139a&scoped=true"
import script from "./maengelTable.vue?vue&type=script&lang=js"
export * from "./maengelTable.vue?vue&type=script&lang=js"
import style0 from "./maengelTable.vue?vue&type=style&index=0&id=70c1139a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c1139a",
  null
  
)

export default component.exports